<script setup lang="ts">
const route = useRoute();
const router = useRouter();

const currentItemId = useRouteQuery<string | undefined>("image", undefined, {
  route,
  router,
});

const emit = defineEmits<{
  "update:isOpen": [value: boolean];
}>();

const props = withDefaults(
  defineProps<{
    items?: GalleryItem[];
    isOpen?: boolean;
  }>(),
  { items: () => [] }
);

const isOpen = useVModel(props, "isOpen", emit, {
  passive: true,
  defaultValue: false,
});

onMounted(() => {
  if (currentItemId.value) {
    isOpen.value = true;
  }
});

const { isMobile } = useUserDevice();

const hideControls = ref(false);
whenever(isOpen, () => (hideControls.value = false));

const hideDetails = computed(() => isMobile.value && hideControls.value);
</script>

<template>
  <AppLightbox
    :item-key="(item) => item.item.id"
    v-model="currentItemId"
    v-model:is-open="isOpen"
    v-bind="{ items, hideDetails, ...$attrs }"
  >
    <template #item-full="{ item, index, onItemLoad }">
      <ImageLightboxFull
        v-bind="{ item, index, hideDetails }"
        :padded-actions="!!$slots['actions']"
        @click:image="() => (hideControls = !hideControls)"
        @load="() => onItemLoad()"
      >
        <template v-if="$slots['actions']" #actions="data">
          <slot name="actions" v-bind="data"></slot>
        </template>
      </ImageLightboxFull>
    </template>
  </AppLightbox>
</template>
